import { useQuery } from '@tanstack/react-query';
import { Flex, Select, Typography } from 'antd';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { STOCK_LOCATIONS_KEY, listStockLocations } from './stock-locations';

const { Text } = Typography;

/**
 * Which shelf the stock comes from (Q98, decided 23 Oct 2026).
 *
 * Starts on `value`, else the branch's main location. A branch with one
 * location has nothing to choose, so the picker is not shown at all and the
 * server uses that location: a phone screen in the workshop stays as it was.
 */
export function StockLocationPicker(props: {
  value: string | undefined;
  onChange: (uid: string) => void;
  label?: string;
}): ReactNode {
  const { t } = useTranslation();
  const { data: locations = [] } = useQuery({ queryKey: STOCK_LOCATIONS_KEY, queryFn: listStockLocations });
  if (locations.length <= 1) return null;

  const shown = props.value ?? locations[0]?.uid;
  return (
    <Flex vertical gap={4}>
      <Text>{props.label ?? t('stockLocation.takeFrom')}</Text>
      <Select
        size="large"
        aria-label={props.label ?? t('stockLocation.takeFrom')}
        value={shown}
        style={{ width: '100%' }}
        options={locations.map((l) => ({
          value: l.uid,
          label: l.isMain ? t('stockLocation.mainOption', { name: l.name, code: l.code }) : `${l.name} (${l.code})`,
        }))}
        onChange={(uid: string) => {
          props.onChange(uid);
        }}
      />
    </Flex>
  );
}
